class CustomerSsoDomainDto {

    Domain: string;
    IsVerified: boolean;
    VerificationRecordName: string;
    VerificationRecordValue: string;

    constructor(domain: string, isVerified: boolean, verificationRecordName: string, verificationRecordValue: string) {
        this.Domain = domain;
        this.IsVerified = isVerified;
        this.VerificationRecordName = verificationRecordName;
        this.VerificationRecordValue = verificationRecordValue;
    }
}

export default CustomerSsoDomainDto;
